import React, { useContext, useEffect, useState, useRef } from "react";
import axios from 'axios';
import { baseURL } from "../../baseURL";
import Cookies from 'js-cookie';

const Dashboard = () => {
  useEffect(() => {
    checkUserAuth();
    // eslint-disable-next-line
  }, []);

  let path = window.location.pathname;
  path = path.split("/");
  var location = path[path.length - 1];
  location = location.split("?")[0];
  
  async function checkUserAuth() {
    const token = Cookies.get('token');
    const data = { token: token }
    try{
      const response = await axios.post(baseURL+'/api/user/auth_check', data)
      if(response.data.status === 'ok') {
          Cookies.set('token', response.data.token, { expires: 1, path: '/'});
          Cookies.set('subscribe', response.data.subscribe, { expires: 1, path: '/'});

          if(location !== 'page-confirm-email' && location !== 'page-confirm-email-checking') {
            if(response.data.email_verified_at === null) {
              window.location.href = '/page-confirm-email';
              return "";
            }
          }

          if(location === 'page-login' || location === 'page-register' || location === 'page-forgot-password') {
            window.location.href = '/';
          }
      } else {
          if(location !== 'page-login' && location !== 'page-register' && location !== 'page-forgot-password' && location !== 'page-confirm-email' && location !== 'page-confirm-email-checking' && location !== 'page-password-reset') {
            window.location.href = '/page-login';
          }
      }
    } catch(e) {
      await delay(2000);
      await checkUserAuth();
    }
  }

  const delay = ms => new Promise(
    resolve => setTimeout(resolve, ms)
  );

  return (
    <></>
  );
};

export default Dashboard;
